import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "primereact/resources/themes/saga-orange/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { LanguageProvider } from "./contexts/LanguageContext";
import { StorageServices } from "./core/services";

library.add(fas, far);

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

rootElement.classList.add("h-100");

const user = StorageServices.GetCookieUser();
const userCultureLocale = user ? user.CultureLocale : "es-ES";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={baseUrl}>
      <LanguageProvider cultureLocale={userCultureLocale}>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>,
  rootElement
);

registerServiceWorker();
